import { Users, BookOpen, School, ShoppingCart } from "lucide-react";
import { cn } from "../../lib/utils";
import { useViewMode } from "../contexts/ViewModeContext";

export default function ViewModeToggle() {
  const { viewMode, setViewMode } = useViewMode();

  return (
    <div
      className="flex items-center rounded-lg bg-button-bg p-0.5 border border-button-border"
      role="group"
      aria-label="Switch between Student, Academics, Campus Life, and Marketplace view"
    >
      <button
        type="button"
        onClick={() => setViewMode("student_life")}
        className={cn(
          "flex items-center gap-2 px-2.5 py-1.5 rounded-md text-xs font-medium transition-all duration-200 border-2 flex-none",
          viewMode === "student_life"
            ? "border-emerald-500 text-emerald-600 dark:text-emerald-400 bg-transparent"
            : "border-transparent text-content-text-muted hover:bg-button-bg-hover hover:text-content-text",
        )}
        title="Student view"
        aria-pressed={viewMode === "student_life"}
      >
        <Users className="w-3.5 h-3.5" />
        <span className="hidden xl:inline">Student</span>
      </button>
      <button
        type="button"
        onClick={() => setViewMode("academics")}
        className={cn(
          "flex items-center gap-2 px-2.5 py-1.5 rounded-md text-xs font-medium transition-all duration-200 border-2 flex-none",
          viewMode === "academics"
            ? "border-violet-600 text-violet-600 dark:text-violet-400 bg-transparent"
            : "border-transparent text-content-text-muted hover:bg-button-bg-hover hover:text-content-text",
        )}
        title="Academics view"
        aria-pressed={viewMode === "academics"}
      >
        <BookOpen className="w-3.5 h-3.5" />
        <span className="hidden xl:inline">Academics</span>
      </button>
      <button
        type="button"
        onClick={() => setViewMode("campus")}
        className={cn(
          "flex items-center gap-2 px-2.5 py-1.5 rounded-md text-xs font-medium transition-all duration-200 border-2 flex-none",
          viewMode === "campus"
            ? "border-blue-600 text-blue-600 dark:text-blue-400 bg-transparent"
            : "border-transparent text-content-text-muted hover:bg-button-bg-hover hover:text-content-text",
        )}
        title="Campus Life view"
        aria-pressed={viewMode === "campus"}
      >
        <School className="w-3.5 h-3.5" />
        <span className="hidden xl:inline">Campus Life</span>
      </button>
      <button
        type="button"
        onClick={() => setViewMode("marketplace")}
        className={cn(
          "flex items-center gap-2 px-2.5 py-1.5 rounded-md text-xs font-medium transition-all duration-200 border-2 flex-none",
          viewMode === "marketplace"
            ? "border-amber-600 text-amber-600 dark:text-amber-400 bg-transparent"
            : "border-transparent text-content-text-muted hover:bg-button-bg-hover hover:text-content-text",
        )}
        title="Marketplace view"
        aria-pressed={viewMode === "marketplace"}
      >
        <ShoppingCart className="w-3.5 h-3.5" />
        <span className="hidden xl:inline">Marketplace</span>
      </button>
    </div>
  );
}
